"use strict";
/**
 * @module Services.TopicAdd
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_add_response_1 = require("./topic-add-response");
/**
 * Serialiser for {@link TopicAddResponse}
 */
var TopicAddResponseSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicAddResponseSerialiserClass, _super);
    function TopicAddResponseSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link TopicAdd} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link TopicAdd} that was read
     */
    TopicAddResponseSerialiserClass.prototype.read = function (bis) {
        var status = Codec.readByte(bis);
        return new topic_add_response_1.TopicAddResponse(status);
    };
    return TopicAddResponseSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicAddResponseSerialiserClass = TopicAddResponseSerialiserClass;
/**
 * The {@link TopicAddResponseSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicAddResponseSerialiser = new TopicAddResponseSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-add/topic-add-response-serialiser.js
// module id = 1466
// module chunks = 0